








































































































// Incluimos los mensajes de este módulo
import ResponseData from "@/models/store/ProveedoresTypesData";
import dataService from "@/services/proveedoresAPI";
import GlobalMixin from "@/mixins/global";
import dialogChooseProvider from "@/components/ModalRegisterContract/DialogChooseProvider.vue";
import Snackbar from "@/components/ModalFormNewResgister/snackbar.vue";
import AutorizationTerms from "@/components/Autorization/AutorizationTerms.vue";

export default GlobalMixin.extend({
  components: {
    dialogChooseProvider,
    AutorizationTerms,
    Snackbar,
  },
  props: ["proveedor", "sociedad", "pedido", "estatus"],
  data: () => ({
    title: "Contratos",
    //Dialog
    dialog: false,
    dialogRefuse: false,
    // snackbar
    snackbar: false,
    text: "",
    timeout: 2000,
    color: "",
    //Datatable
    moduleName: "DATATABLE_CONTRACT_LIST",
    headerProps: {
      sortByText: "Ordenar por",
    },
    footerProps: {
      itemsPerPageText: "Registros por página",
      itemsPerPageAllText: "Todos",
      pageText: "{0}-{1} de {2}",
      sortByText: "Ordenar por",
    },
    loadingText: "Cargando... Por favor espere",
    noDataText: "Sin datos",
    loading: true,

    headerContractList: [],
    items: [],
    termsConditions: [],

    // Registros
    editedIndex: -1,
    editedItem: {},
    enabledEdit: 0,
    keyFileTempRefuse: "",
  }),
  methods: {
    // Metodos dialogo
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    resetIndexItem() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, {});
        this.editedIndex = -1;
      });
    },
    refuseItem(item: any) {
      this.keyFileTempRefuse = item.docBucketKeyFile;
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogRefuse = true;
    },
    RefuseItemConfirm() {
      this.closeRefuse();
    },
    closeRefuse() {
      this.dialogRefuse = false;
      this.resetIndexItem();
    },
    saveItemRefuse() {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem);
      }
      this.closeRefuse();
    },

    // Activar notificacion
    notificacion(mensaje: string, color: string) {
      this.text = mensaje;
      this.color = color;
      this.snackbar = true;
      window.setTimeout(() => {
        this.snackbar = false;
      }, this.timeout);
    },

    //Metodo para inicializar procesos
    ini() {
      //Datatable de la lista de contrato
      (this.headerContractList = [
        {
          text: "No. Proveedor",
          value: "docProveedor",
          align: "start",
          filter: this.getfilterProv,
        },
        {
          text: "Nombre proveedor",
          value: "proveedorRazonSocial",
        },
        {
          text: "No. OC",
          value: "docOCNumero",
          filter: this.getfilterPedido,
        },
        {
          text: "Sociedad",
          value: "sociedad",
          filter: this.getfilterSoc,
        },
        {
          text: "Estatus",
          value: "docEstatusID",
          filter: this.getfilterEstatus,
          template: this.getStatus,
          color: this.getColor,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
        },
      ]),
        //Obtiene la lista de contratos
        this.getContractList();
    },
    getContractList() {
      let isAuthorizerObra =
        this.$store.getters["auth/rol"] == "1" ? true : false;
      let isAdmin = ["4", "5"].includes(this.$store.getters["auth/rol"]) ? true : false;
      dataService
        .getTermsConditions()
        .then((Response: ResponseData) => {
          if (Response.data.data[0]) {
            Response.data.data.forEach((itemR: any) => {
              if (isAdmin) {
                this.items.push(itemR);
              } else {
                if (itemR.proveedorObra && isAuthorizerObra) {
                  this.items.push(itemR);
                } else if (!itemR.proveedorObra && !isAuthorizerObra) {
                  this.items.push(itemR);
                }
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    autorizar(item: any) {
      this.editedIndex = this.items.indexOf(item);
      dataService
        .approveDocuments(item.docID)
        .then((Response: ResponseData) => {
          item.docEstatusID = 2;
          Object.assign(this.items[this.editedIndex], item);
          this.text = "Registro autorizó";
          this.snackbar = true;
          this.color = "success";
          this.resetIndexItem();
        })
        .catch((e: Error) => {
          console.log(e);
          this.text = "No se autorizó el registro, intente de nuevo más tarde ";
          this.snackbar = true;
          this.color = "red darken-2";
          this.resetIndexItem();
        });
    },
    //Filtros
    getfilterSoc(value: any) {
      // If this filter has no value we just skip the entire filter.
      if (!this.sociedad) {
        return true;
      }
      let noSociedad = this.sociedad.empresaClave;
      let values = value.toString();
      return values.toLowerCase().includes(noSociedad.toLowerCase());
    },
    getfilterProv(value: any) {
      // If this filter has no value we just skip the entire filter.
      if (!this.proveedor) {
        return true;
      }
      let noProveedor = this.proveedor.userID;
      let values = value.toString();
      return values.toLowerCase().includes(noProveedor.toLowerCase());
    },
    getfilterPedido(value: any) {
      // If this filter has no value we just skip the entire filter.
      if (!this.pedido) {
        return true;
      }
      let values = value.toString();
      return values.toLowerCase().includes(this.pedido.toLowerCase());
    },
    getfilterEstatus(value: any) {
      // If this filter has no value we just skip the entire filter.
      if (!this.estatus) {
        return true;
      }
      return value === this.estatus.id;
    },
    //
    getStatus(value: number) {
      switch (value) {
        case 0:
          return "Inactivo - eliminado";
          break;
        case 1:
          return "Activo - Pendiente a ser autorizado";
          break;
        case 2:
          return "Autorizado";
          break;
        case 3:
          return "Rechazado";
          break;
        case 4:
          return "Cancelado por el SAT";
          break;
        default:
          return "Inactivo";
          break;
      }
    },
    getColor(value: number) {
      switch (value) {
        case 0:
          return "blue-grey";
          break;
        case 1:
          return "orange";
          break;
        case 2:
          return "green";
          break;
        case 3:
          return "red";
          break;
        case 4:
          return "red";
          break;
        default:
          return "blue-grey";
          break;
      }
    },
  },
  mounted() {
    this.ini();
  },
});
